import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import backgroundGradient from '../../bg-gradient.png';

interface AcrylicProps {
    image?: string | null;
    theme: string;
}

const useStyles = makeStyles({
    root: {
        position: 'absolute',
        width: '100vw',
        height: '100vh',
        zIndex: 0,
        display: 'block',
        right: 0,
        padding: 0,
        backgroundSize: 'cover !important',
        backgroundPosition: 'center',
        maxWidth: '100vw !important',
        pointerEvents: 'none',
    },
    overlayDark: {
        width: '100%',
        height: '100%',
        opacity: 0.55,
        background: 'linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)',
    },
    overlayLight: {
        width: '100%',
        height: '100%',
        opacity: 0.6,
        background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)',
    },
    container: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
    },
});

const Acrylic: React.FC<AcrylicProps> = ({ image, theme }) => {
    const classes = useStyles();

    return (
        <div
            className={classes.root}
            style={{ background: `url(${image ?? backgroundGradient})` }}
        >
            <div className={theme === 'dark' ? classes.overlayDark : classes.overlayLight}></div>
            <div className={classes.container}></div>
        </div>
    );
};

export default Acrylic;
